export const tabList = [
  {label: 'Cabinet Devices', value: 'cabinetDevices'},
  {label: 'Device Status', value: 'deviceStatus'},
  {label: 'User Devices', value: 'userDevices'},
  {label: 'User Metrics', value: 'userMetrics'}
]

export const DashboardIds = [
  '67ab29f2b6abe50033c5be48',
  '67ab2a21b6abe50033c5be51',
  '67ab2a4eb6abe50033c5be5a',
  '67ab2a79b6abe50033c5be66'
]
